import React, { useEffect } from 'react';

import { Button, Form, Input, Modal, Upload, message } from 'antd';

import { UploadOutlined } from '@ant-design/icons';

import { Field } from '../../../models/Field';

interface Props {
    open: boolean;
    field: Field | null;
    onCancel: () => void;
    onSubmit: (data: Partial<Field>) => void;
}

const FieldForm = (props: Props) => {
    const [form] = Form.useForm();
    const { open, field, onCancel, onSubmit } = props;

    useEffect(() => {
        if (!open) {
            return;
        }
        if (field && field.id) {
            form.setFieldsValue({
                name: field.name,
                location: field.location,
                geo_json: field.geo_json,
            });
        } else {
            form.resetFields();
        }
    }, [open, field, form]);

    const validateGeoJSON = (_: any, value: string) => {
        if (!value) {
            return Promise.reject(new Error('GeoJSON обязателен'));
        }
        try {
            const parsed = JSON.parse(value);
            if (parsed.type !== 'FeatureCollection') {
                return Promise.reject(new Error('Ожидается FeatureCollection'));
            }
        } catch (e) {
            return Promise.reject(new Error('Некорректный JSON'));
        }
        return Promise.resolve();
    };

    const beforeUpload = (file: File) => {
        const reader = new FileReader();
        reader.onload = () => {
            const text = String(reader.result || '');
            form.setFieldsValue({ geo_json: text });
            message.success(`Файл ${file.name} прочитан`);
        };
        reader.onerror = () => {
            message.error('Не удалось прочитать файл');
        };
        reader.readAsText(file);
        return false;
    };

    const handleOk = () => {
        form.validateFields()
            .then((values) => onSubmit(values))
            .catch(() => undefined);
    };

    return (
        <Modal
            title={field && field.id ? 'Редактировать поле' : 'Создать поле'}
            open={open}
            onCancel={onCancel}
            onOk={handleOk}
            width={720}
            okText="Сохранить"
            cancelText="Отмена"
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Название"
                    rules={[{ required: true, message: 'Укажите название' }]}
                >
                    <Input placeholder="Например: Поле №1" />
                </Form.Item>
                <Form.Item name="location" label="Локация">
                    <Input placeholder="Опционально" />
                </Form.Item>
                <Form.Item
                    name="geo_json"
                    label="GeoJSON"
                    rules={[{ validator: validateGeoJSON }]}
                    extra="Вставьте GeoJSON из Yandex Map Constructor или загрузите файл .geojson"
                >
                    <Input.TextArea
                        rows={10}
                        placeholder='{"type": "FeatureCollection", "features": [...]}'
                    />
                </Form.Item>
                <Upload beforeUpload={beforeUpload} showUploadList={false} accept=".geojson,.json">
                    <Button icon={<UploadOutlined />}>Загрузить .geojson</Button>
                </Upload>
            </Form>
        </Modal>
    );
};

export default FieldForm;
